import React, { memo } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Switch, Route, BrowserRouter, HashRouter } from "react-router-dom";
import {
  AppSnackbar,
  ImagesPreloader,
  PageWrapper,
  RotationWarningOverlay,
} from "components";
import useAppHooks from "./index.hooks";
import {
  ChooseLevelPage,
  DemoPage,
  GamePage,
  HomePage,
  TutorialPage,
} from "scenes";
import ReactAudioPlayer from "react-audio-player";
const countdownAudio = require("assets/audio/countdown.mp3");
const swooshAudio = require("assets/audio/swoosh.wav");
const fermatesseraAudio = require("assets/audio/fermatessera.mp3");
const freezeAudio = require("assets/audio/freeze.mp3");
const freezeResumeAudio = require("assets/audio/freeze-resume.mp3");
const winAudio = require("assets/audio/win.wav");
const gameOverAudio = require("assets/audio/game-over.mp3");

const App: React.FC = () => {
  const { theme } = useAppHooks();

  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <CssBaseline />
        <Switch>
          <Route path="/tutorial" component={TutorialPage} />
          <Route path="/choose-level" component={ChooseLevelPage} />
          <Route path="/game" component={GamePage} />
          <Route path="/" component={HomePage} />
        </Switch>
      </HashRouter>
      <AppSnackbar />
      <RotationWarningOverlay />
      <ImagesPreloader />
      <ReactAudioPlayer
        preload="auto"
        id="countdownAudioId"
        src={countdownAudio}
      />
      <ReactAudioPlayer preload="auto" id="swooshAudioId" src={swooshAudio} />
      <ReactAudioPlayer
        preload="auto"
        id="fermatesseraAudioId"
        src={fermatesseraAudio}
      />
      <ReactAudioPlayer preload="auto" id="freezeAudioId" src={freezeAudio} />
      <ReactAudioPlayer
        preload="auto"
        id="freezeResumeAudioId"
        src={freezeResumeAudio}
      />
      <ReactAudioPlayer preload="auto" id="winAudioId" src={winAudio} />
      <ReactAudioPlayer
        preload="auto"
        id="gameOverAudioId"
        src={gameOverAudio}
      />
    </ThemeProvider>
  );
};

export default memo(App);
